var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "ybl-table",
      staticClass: "ybl-table",
      class: {
        "mutil-rows": _vm.$attrs.mutil,
        nowrap: _vm.$attrs.nowrap,
        newUI: _vm.$attrs.newUI
      }
    },
    [
      _c(
        "el-table",
        _vm._g(
          _vm._b(
            { ref: "table", attrs: { data: _vm.data } },
            "el-table",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.total > 10
        ? _c(
            "div",
            { staticClass: "ybl-table__page" },
            [
              _c("ybl-pager", {
                attrs: {
                  total: _vm.total,
                  size: _vm.size,
                  monitor:
                    _vm.$attrs.monitor === undefined || !!_vm.$attrs.monitor
                },
                on: { change: _vm.change, "size-change": _vm.sizeChange }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-783f90ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-783f90ce","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Table.vue
// module id = null
// module chunks = 